import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matchScoreClass',
  standalone: true
})
export class MatchScoreClassPipe implements PipeTransform {
  /**
   * Transform match score to CSS class based on embedding similarity score.
   *
   * Score interpretation (cosine similarity from pgvector):
   * - 0.85+: Excellent - Strong match on most criteria
   * - 0.70-0.84: Very Good - Solid match, some differences
   * - 0.55-0.69: Good - Moderate/partial overlap
   * - 0.40-0.54: Fair - Few matching attributes
   * - <0.40: Poor - Little in common
   *
   * @param score - Raw similarity score (0-1) or percentage (0-100)
   * @returns CSS class name for styling
   */
  transform(score: number | null | undefined): string {
    if (!score || score === null || score === undefined) return 'match-score-unavailable';

    // Normalize to decimal (0-1) if percentage was passed
    const rawScore = score > 1 ? score / 100 : score;

    if (rawScore >= 0.85) return 'match-score-excellent';
    if (rawScore >= 0.70) return 'match-score-very-good';
    if (rawScore >= 0.55) return 'match-score-good';
    if (rawScore >= 0.40) return 'match-score-fair';
    return 'match-score-poor';
  }
}
